(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/dialogs/playing-next-draw.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/dialogs/playing-next-draw.js');

'use strict';

const _svs$numbergames$prod = svs.numbergames.productMapping,
  PRODUCT_CONSTANTS = _svs$numbergames$prod.CONSTANTS,
  getProductId = _svs$numbergames$prod.getProductId,
  getDay = _svs$numbergames$prod.getDay;
class PlayingNextDraw extends svs.tur.payment.dialogs.DialogBase {
  constructor() {
    let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      productNumeric = _ref.productNumeric,
      regCloseTime = _ref.regCloseTime,
      onConfirm = _ref.onConfirm,
      onCancel = _ref.onCancel;
    super({
      onConfirm,
      onCancel
    });
    this.productNumeric = productNumeric;
    this.regCloseTime = regCloseTime;
    this.show();
  }
  getIcon() {
    return 'exclamation-sign';
  }
  getTitle() {
    switch (getProductId(this.productNumeric)) {
      case PRODUCT_CONSTANTS.LOTTO:
      case PRODUCT_CONSTANTS.EUROJACKPOT:
        return "".concat(getDay(this.productNumeric), "ens spel \xE4r st\xE4ngt");
      default:
        return 'Dagens spel är stängt';
    }
  }
  getMessage() {
    return [{
      type: svs.components.dialog.message.TEXT,
      text: this.getMessageText()
    }];
  }
  getMessageText() {
    switch (getProductId(this.productNumeric)) {
      case PRODUCT_CONSTANTS.KENO:
        return 'Du deltar i morgondagens spelomgång.';
      default:
        return "Du deltar i n\xE4sta veckas spelomg\xE5ng med dragning<br />".concat(svs.utils.date.FormatTime('eeee d/M', this.regCloseTime));
    }
  }
  getActions() {
    return [{
      title: 'Avbryt',
      callback: (e, forms, dialog) => {
        dialog.close();
        if (this.onCancel) {
          this.onCancel();
        }
      }
    }, {
      title: "Forts\xE4tt",
      callback: (e, forms, dialog) => {
        dialog.close();
        if (this.onConfirm) {
          this.onConfirm();
        }
      }
    }];
  }
}
svs.tur.payment.dialogs.PlayingNextDraw = PlayingNextDraw;

 })(window);